const LANGUAGE_KEY = "hi-reach-language";
import store from "@/store";
import { mapGetters } from "vuex";

export const getLanguage = () => {
	return (window.localStorage.getItem(LANGUAGE_KEY) ? window.localStorage.getItem(LANGUAGE_KEY) : 'en');
};

export const getText = key => {
	let TEXT_LIST = require("@/assets/text/"+getLanguage()+".text.list");
	if(TEXT_LIST.TEXT_LIST !== undefined && TEXT_LIST.TEXT_LIST[key] !== undefined) {
		// Check if user has over-written keys in their config
		if(store !== undefined && store.getters !== undefined && store.getters.merchant !== undefined) {
			let merchant = store.getters.merchant;
			if(merchant.Text !== undefined && merchant.Text[key] !== undefined) {
				return merchant.Text[key];
			}
		}
		// Otherwise return Language'd string
		return TEXT_LIST.TEXT_LIST[key];
	} else {
		console.warn('Translation not found', key)
		return TEXT_LIST.TEXT_LIST["NotFound"] || "--";
	}
};

export const getError = key => {
	let ERROR_LIST = require("@/assets/errors/"+getLanguage()+".error.list");
	if(ERROR_LIST.ERROR_LIST !== undefined && ERROR_LIST.ERROR_LIST[key] !== undefined) {
		// Check if user has over-written keys in their config
		if(store !== undefined && store.getters !== undefined && store.getters.merchant !== undefined) {
			let merchant = store.getters.merchant;
			if(merchant.ErrorText !== undefined && merchant.ErrorText[key] !== undefined) {
				return merchant.ErrorText[key];
			}
		}
		return ERROR_LIST.ERROR_LIST[key];
	} else {
		console.warn('Translation not found', key)
		return ERROR_LIST.ERROR_LIST["NotFound"];
	}
};

export const setLanguage = lang => {
	window.localStorage.setItem(LANGUAGE_KEY, lang);
};

export default { getLanguage, setLanguage, getText, getError };
